export const en = {
  appTitle: 'Hmlet Marketing',
  signIn: 'Sign in',
  signOut: 'Sign out',
  username: 'Username',
  password: 'Password',
  loginFailed: 'Wrong username or password',
  panelPipedrive: 'Pipedrive',
  panelGa4: 'GA4',
  panelAds: 'Ad platforms',
  panelOccupancy: 'Occupancy',
  period: 'Period',
  compare: 'Compare',
  mtd: 'Month to date',
  last_7: 'Last 7 days',
  yesterday: 'Yesterday',
  last_30: 'Last 30 days',
  last_90: 'Last 90 days',
  ytd: 'Year to date',
  applyRange: 'Apply',
  last_month: 'Last month',
  custom: 'Custom',
  cmpNone: 'None',
  cmpPrev: 'Previous period',
  cmpWow: 'Week over week',
  cmpYoy: 'Year over year',
  from: 'From',
  to: 'To',
  pickRange: 'Choose a date range',
  dataThrough: 'Data through',
  stale: 'Data may be out of date',
  noComparison: 'No data for the comparison period',
  historyShort: 'No history yet',
  historyStarts: 'Comparison data starts {{date}}. Earlier days are not in the dashboard.',
  goalsMtdCaption: 'Month to date through yesterday, against the monthly target. Pick another period above and the goals follow it.',
  goalsPeriodCaption: 'The goals follow the period above. The month-end number is projected from that period\'s daily pace and compared with the whole monthly target.',
  secGoalsPeriod: 'Selected period vs target',
  goalPeriodVsTarget: 'of the monthly target so far',
  goalPeriodBasis: 'based on the last {{days}} days',
  secPeriod: 'Selected period',
  secGoalsMtd: 'Month to date vs target',
  tileOccupancy: 'Occupancy rate',
  occupancyAt: 'End of {{month}}',
  secCategories: 'Leads by category',
  catA: 'A booking',
  catB: 'B enquiry',
  catLine: 'LINE',
  catWeb: 'Web (A and B not split)',
  catWebsite: 'Website (hmlet.com)',
  catOtherChannels: 'Other marketing channels',
  catOther: 'Other (LINE, unsplit)',
  chartCohort: 'Lead cohort CVR over time',
  sectionGaLeads: 'Leads by channel (Google Analytics)',
  gaLeadsMonthlyNote: 'February to May 2026 are monthly numbers from the Marketing sheet (tracking of these events in the dashboard starts on 19 May). They are in the totals and the channel table when the whole month is in the period, and they have no days, so the daily chart starts in June 2026.',
  gaLeadsNote: 'Leads that GA4 counted on the Category A and B thank-you pages, by the channel that first brought the visitor, as in the Marketing sheet. These are GA4 events, so the total differs from the Pipedrive lead count. Website wide, not split by region.',
  tileGaLeads: 'Leads (GA4)',
  tileGaLeadsA: 'Category A (GA4)',
  tileGaLeadsB: 'Category B (GA4)',
  chartGaLeadsDaily: 'Daily leads counted by GA4',
  tableGaLeads: 'Leads by channel (GA4)',
  colShare: 'Share',
  sectionPages: 'Page visitors (unique users)',
  pagesNote: 'Unique users per day on the website pages Marketing tracks. Page data covers the whole website, so the region switch does not change it.',
  tilePageTop: 'Top page users',
  tilePageSearch: 'Property search page users',
  tilePageRoom: 'Room page users',
  chartPageTop: 'Top page users per day',
  chartPageSearch: 'Property search page users per day, by city',
  chartPageRoom: 'Room page users per day',
  tablePageProperties: 'Room page users by property',
  colUsers: 'Users',
  colPropertyId: 'Property ID',
  cityTokyo: 'Tokyo',
  cityOsaka: 'Osaka',
  citySingapore: 'Singapore',
  cityHongKong: 'Hong Kong',
  chartCohortBars: 'Leads and contracts by lead month',
  cohortBarsNote: 'Each month shows the leads created in it and how many of those leads have signed a contract so far (the contract can be signed in a later month). The CVR is printed under the month. The current month is still accumulating. Invalid leads are excluded.',
  cohortCvrShort: 'CVR',
  cohortNote: 'Share of each month\'s leads that signed a contract, by months since the lead month, through {{date}}. The current month is still accumulating. Invalid leads are excluded. {{skipped}} contracts signed before their lead was created are ignored.',
  cohortMaturing: 'still accumulating',
  cohortOffset: '{{n}} months after the lead month',
  cohortAt0: 'Same month',
  cohortAt1: '+1 month',
  cohortAt2: '+2 months',
  cohortToDate: 'To date',
  colTotal: 'Total',
  chartMoveInActual: 'Actual move-in month (signed contracts)',
  moveInDesiredNote: 'Desired move-in month of the leads created in the range.',
  moveInActualNote: 'Move-in month of the contracts signed in the range.',
  moveInMissingNote: 'Move-in month of the contracts signed in the range. {{n}} contracts have no move-in date and are not shown.',
  chartDailyLeadsByCategory: 'Daily leads by category',
  hintContractRate: 'Contract rate {{pct}}',
  tileCrTotal: 'Contracts per lead (period)',
  periodRatioHint: 'Contracts signed in the range divided by leads created in the range. Not a cohort rate.',
  tileAdLeadsA: 'Ad leads A (booking)',
  tileAdLeadsB: 'Ad leads B (enquiry)',
  hintContractsOf: '{{n}} contracts, {{of}} leads',
  tileContractRateA: 'Contract rate A (period)',
  tileContractRateB: 'Contract rate B (period)',
  periodShortened: 'Period shortened to the days with confirmed data',
  searchThrough: 'Search Console data through',
  tileCost: 'Ad spend',
  tileImpressions: 'Impressions',
  tileClicks: 'Clicks',
  tileLeadsA: 'Leads A (booking)',
  tileLeadsB: 'Leads B (enquiry)',
  tileCpl: 'Cost per lead',
  tileSessions: 'Sessions',
  tileEngaged: 'Engaged sessions',
  tileEngagement: 'Engagement rate',
  tileSearchClicks: 'Search clicks',
  tileSearchImpr: 'Search impressions',
  tileSearchPos: 'Avg search position',
  vsPrevious: 'vs comparison period',
  chartDailySpend: 'Daily ad spend',
  chartDailyLeads: 'Daily leads (A + B)',
  chartDailySessions: 'Daily sessions',
  chartChannelGroups: 'Sessions by channel group',
  tableCampaigns: 'Campaigns',
  tableSources: 'Sources',
  viewChart: 'Chart',
  viewTable: 'Table',
  colDate: 'Date',
  colCampaign: 'Campaign',
  colType: 'Type',
  colCost: 'Cost',
  colImpr: 'Impr.',
  colClicks: 'Clicks',
  colLeadsA: 'Leads A',
  colLeadsB: 'Leads B',
  colLeads: 'Leads',
  colOther: 'Other',
  colCpl: 'CPL',
  colSource: 'Source / medium',
  colChannel: 'Channel group',
  colSessions: 'Sessions',
  colEngRate: 'Engagement',
  colKeyEvents: 'Key events',
  seriesCurrent: 'This period',
  seriesPrevious: 'Comparison',
  notConnected: 'Not connected yet',
  needsPipedrive:
    'Leads and contracts by UTM, CPL, CPA and the month-end forecast come from Pipedrive. Waiting for a read-only API token and the field map.',
  needsOccupancy:
    'The end-of-month occupancy rate (domestic Japan properties) will come from the Sales team sheet once it is shared and the formula is confirmed.',
  leadsNote:
    'Leads are what the ad platform reports (booking and enquiry completions). Pipedrive-confirmed leads will replace them.',
  forecastTitle: 'Month-end forecast',
  forecastNote:
    'Estimate, not a promise: month to date divided by elapsed days, extended to the full month.',
  forecastNow: 'So far',
  forecastEnd: 'Forecast',
  goalTitle: 'Ad leads vs target',
  noTarget: 'No target set for this month. Add one in the admin (Targets, metric ad_leads).',
  goalTarget: 'Target',
  goalProgress: 'of target reached',
  goalPace: 'pace',
  goalForecast: 'forecast vs target',
  days: 'days',
  dataSources: 'Data sources',
  neverRun: 'never run',
  loading: 'Loading',
  error: 'Something went wrong',
  retry: 'Retry',
  pageNotFound: 'Page not found',
  navOverview: 'Overview',
  navGroupSources: 'Data sources',
  navGroupExplore: 'Explore',
  navGroupSystem: 'System',
  navGoogleAds: 'Google Ads',
  navSearch: 'Search Console',
  navMeta: 'Meta Ads',
  navReddit: 'Reddit Ads',
  navGoals: 'Goals',
  navFunnel: 'Funnel',
  navChannels: 'Channels',
  navCreatives: 'Creatives',
  navHealth: 'Data health',
  navGlossary: 'Glossary',
  panelGlossary: 'Glossary',
  qGlossary: 'What does each number mean, and how is it calculated?',
  glossaryWhat: 'What it is',
  glossaryFormula: 'How it is calculated',
  glossarySource: 'Where it comes from',
  glossaryCaution: 'Watch out',
  glossaryMore: 'See all definitions',
  glossaryAria: 'What is {{name}}?',
  glossarySearch: 'Search a term',
  glossaryNone: 'No term matches the search.',
  glossaryExport: 'Download as CSV',
  qOverview: 'Is this month on track, what does it cost, where do leads come from, and can I trust the numbers?',
  qAds: 'Is paid media efficient? Spend, leads and cost per lead by campaign.',
  qGa4: 'What is the traffic and how does it behave?',
  qSearch: 'How does the website appear in organic search?',
  qPipedrive: 'How many confirmed leads and contracts are there, and where do they come from?',
  qOccupancy: 'How full are the properties?',
  qGoals: 'Is performance on track against the monthly targets, and by how much?',
  qFunnel: 'Where are people lost between visit, lead and contract?',
  qChannels: 'Which channels earn their cost?',
  qCreatives: 'Which ads work?',
  qHealth: 'Can I trust what I see?',
  exportCsv: 'Download CSV',
  annOutage: 'Tracking issue',
  annMaturing: 'Still maturing',
  annNote: 'Note',
  statusAhead: 'Ahead',
  statusOnPace: 'On pace',
  statusBehind: 'Behind',
  statusNoTarget: 'No target',
  statusNoData: 'No data',
  srcName_google_ads: 'Google Ads',
  srcName_ga4: 'GA4 sessions',
  srcName_ga4_pages: 'GA4 page visitors',
  srcName_ga4_leads: 'GA4 leads by channel',
  srcName_ga4_completions: 'GA4 thank-you completions by session channel',
  srcName_gsc: 'Search Console',
  srcName_pipedrive: 'Pipedrive',
  srcName_meta: 'Meta (ad sheet)',
  srcName_reddit: 'Reddit',
  srcName_chatgpt: 'ChatGPT Ads',
  srcName_sheet: 'Targets and costs sheet',
  srcName_occupancy: 'Occupancy sheet',
  srcName_leads_sheet: 'Leads by channel sheet',
  runStatus_ok: 'OK',
  runStatus_failed: 'Failed',
  runStatus_never_run: 'Not connected',
  statusStale: 'delayed',
  goalLeads: 'Leads',
  goalAdLeads: 'Ad leads (platform reported)',
  goalContracts: 'Contracts',
  waitingPipedrive: 'Waiting for Pipedrive. Confirmed leads and contracts appear once it is connected.',
  waitingShort: 'Waiting for Pipedrive',
  noTargetShort: 'no target set',
  goalForecast2: 'Forecast',
  needPerDay: '{{n}} per day needed to hit the target',
  basisPlatform: 'Platform-reported (ad click conversions)',
  basisConfirmed: 'Confirmed (Pipedrive)',
  basisPlatformShort: 'Platform-reported',
  funnelSessions: 'Sessions',
  funnelKeyEvents: 'Key events',
  funnelLeads: 'Leads',
  funnelContracts: 'Contracts',
  funnelWeakest: 'Weakest step',
  funnelByChannel: 'Funnel by channel',
  rateSessionsToLeads: 'Sessions to leads',
  rateLeadsToContracts: 'Leads to contracts',
  keyEventsNote: 'GA4 key events are not configured yet, so that step is hidden.',
  colChannelName: 'Channel',
  colLeadsPlatform: 'Leads (platform)',
  colContracts: 'Contracts',
  colCpa: 'CPA',
  colSpendShare: 'Spend share',
  colContractShare: 'Contract share',
  badgeAd: 'Ad',
  colMonth: 'Month',
  colQuery: 'Query',
  colPage: 'Page',
  colPosition: 'Position',
  colSourceName: 'Source',
  colStatus: 'Status',
  colLastRun: 'Last run',
  colRows: 'Rows',
  colPeriod: 'Period',
  colNote: 'Note',
  tileTotalCost: 'Total ad spend',
  tileOverallCpl: 'Overall CPL',
  tileAdCpl: 'Ad CPL (platform reported)',
  tileCpa: 'CPA',
  overLimit: 'Over the limit of',
  underLimit: 'Within the limit of',
  tileCtr: 'CTR',
  tileKeyEvents: 'Key events',
  keyEventsOff: 'Not configured',
  tileLine: 'LINE leads',
  lineCounted: 'Counted as leads',
  lineNotCounted: 'Not counted as leads',
  tileInvalid: 'Invalid leads',
  invalidNote: 'Deducted from leads',
  byMoveIn: 'By move-in date',
  byContractDate: 'By contract date',
  tileCwRate: 'Contracts per lead (period)',
  tileDaysToContract: 'Median days to contract',
  chartDailyClicks: 'Daily clicks',
  chartDailyImpr: 'Daily impressions',
  chartDailyContracts: 'Daily contracts',
  chartMoveIn: 'Desired move-in month',
  chartCountries: 'Leads by country',
  chartOccupancy: 'Occupancy rate, end of month',
  chartCumulative: 'Month to date vs target: {{metric}}',
  tableChannels: 'Channels',
  seeChannels: 'Open the channel view',
  tableUtm: 'Leads and contracts by UTM',
  tableMonthly: 'Month by month {{year}}',
  shareTitle: 'Share of spend versus share of contracts',
  mappingTitle: 'How UTM maps to channels',
  mappingNote: 'The first matching rule wins. * matches anything or the start of a value.',
  mappingAdmin: 'Edit the rules in the admin (Channels and Channel rules).',
  brandSplit: 'Brand versus generic queries (clicks)',
  brandQueries: 'Brand',
  genericQueries: 'Generic',
  topQueries: 'Top queries',
  topPages: 'Top pages',
  secGoals: 'Goals',
  secEfficiency: 'Cost and efficiency',
  secFunnel: 'Funnel',
  changesTitle: 'What changed',
  changesNone: 'Nothing moved beyond the thresholds.',
  changesPickComparison: 'Pick a comparison above to see what changed.',
  chgCampaignCpl_up: '{{subject}}: cost per lead up {{pct}}% ({{before}} to {{now}})',
  chgCampaignCpl_down: '{{subject}}: cost per lead down {{pct}}% ({{before}} to {{now}})',
  chgSessions_up: '{{subject}} sessions up {{pct}}% ({{before}} to {{now}})',
  chgSessions_down: '{{subject}} sessions down {{pct}}% ({{before}} to {{now}})',
  chgPosition_better: 'Average search position improved by {{delta}} ({{before}} to {{now}})',
  chgPosition_worse: 'Average search position worsened by {{delta}} ({{before}} to {{now}})',
  chgClicks_up: 'Search clicks up {{pct}}% ({{before}} to {{now}})',
  chgClicks_down: 'Search clicks down {{pct}}% ({{before}} to {{now}})',
  trustTitle: 'Can I trust this?',
  reconNote: 'Ad platforms report {{platform}} ad leads, Pipedrive confirms {{confirmed}} (gap {{gap}}).',
  reconNone: 'Platform and confirmed leads are compared here once Pipedrive is connected.',
  occupancyChip: 'Occupancy {{rate}} at the end of {{month}}',
  issuesCount_one: '{{count}} known data issue in this period',
  issuesCount_other: '{{count}} known data issues in this period',
  needsAdsCsv: '{{platform}} is not connected yet. Load an export with: python manage.py ingest {{platform}} --csv file.csv',
  needsCreatives: 'Creatives appear after the first Google Ads refresh (python manage.py ingest google_ads).',
  creativesNote: 'Results are platform-reported. Ads that led to confirmed contracts come with Pipedrive ad-level tracking.',
  creativesShown: 'Shown',
  sortBy: 'Sort by',
  sort_cost: 'Spend',
  sort_leads: 'Leads',
  sort_clicks: 'Clicks',
  sort_ctr: 'CTR',
  noImage: 'No image',
  goalActual: 'Actual',
  goalTargetLine: 'Target pace',
  goalsPlan: 'Targets from the {{plan}}. Ahead means forecast at or above {{ahead}} of target, behind means below {{behind}}.',
  planQ2: 'Q2 plan',
  planBudget: 'budget block (KPI sheet)',
  costAgency: 'Agency fee ({{rate}}%)',
  costScope: 'Cost is ad platform spend plus the agency fee. Only connected platforms (Google Ads for now) are counted; Meta, Reddit and ChatGPT will be added when connected. Instagram operation and other costs are not included.',
  monthlyNote: 'Actuals before the connected sources come from the Marketing monthly workbook.',
  campaignDetailNote: 'Daily cost, leads and cost per lead for the selected period.',
  occLatest: 'Occupancy',
  occPrevious: 'Previous month',
  occNote: 'End of month rate, domestic Japan properties, from the Sales team sheet.',
  wsTitle: 'Project status',
  wsIntro: 'Current status of the dashboard: what is available, what is in progress, which inputs are pending and what is planned.',
  ws_done: 'done',
  ws_partial: 'in progress',
  ws_waiting: 'pending input',
  ws_todo: 'planned',
  wsItem: 'Item',
  wsUnlocks: 'Detail',
  wsNext: 'Detail',
  wsNeeds: 'Detail',
  wsGroup_feature: 'Available now',
  wsGroup_access: 'Access',
  wsGroup_stakeholder: 'Inputs pending',
  wsGroup_engineering: 'Planned work',
  wsGroup_later: 'Later',
  wsFeatureNote: 'Done means it works with real data. In progress means it works with a known limit.',
  wsAccessNote: 'Logins, shares and keys the dashboard relies on.',
  wsAnswerNote: 'Definitions and decisions that determine the next changes.',
  wsOursNote: 'Engineering work that is planned.',
  wsLaterNote: 'Ideas on the roadmap that come after the basics.',
  healthSources: 'Sources',
  healthIssues: 'Known data issues',
  healthCosts: 'Dashboard ad spend versus the Marketing web ad cost',
  healthRuns: 'Recent refresh runs',
  issuesAdmin: 'Add or edit issues in the admin (Annotations).',
  costNone: 'No months to compare yet.',
  costOurs: 'Dashboard',
  costReported: 'Marketing reported',
  costGap: 'Difference',
  costGapNote: 'The Marketing figure is above the ad platform spend since May 2026. What it includes (other platforms, agency fee or margin) has not been confirmed.',
  plan_budget: 'budget',
  plan_q2: 'Q2',
  targetPlanLine: 'Targets in use: {{plan}} plan.',
  unattributed: 'Unattributed',
  toggleTheme: 'Toggle theme',
  searchScopeNote: 'Search Console covers the whole hmlet.com domain (all countries), not only Japan. Pages are shown with their host.',
  tileLeadsWeb: 'Web leads (A and B not split)',
  tileLeadsWebsite: 'Website leads',
  tileLeadsOther: 'Other channel leads',
  tileWebAdLeads: 'Web Ad Leads',
  insTitle: 'AI insights',
  insLoading: 'Loading insights',
  insNotConfigured: 'AI insights are not set up on this server yet.',
  insNone: 'No insights generated yet for this region. They are created once a day, or press Regenerate.',
  insImpact_high: 'High impact',
  insImpact_medium: 'Medium impact',
  insImpact_low: 'Low impact',
  insWhy: 'Why it matters:',
  insAction: 'Next step:',
  insRisks: 'Risks',
  insCaveats: 'Data caveats',
  insRegenerate: 'Regenerate',
  insGenerating: 'Generating, about a minute',
  insCooldown: 'Available again in {{n}} min',
  insGenerated: 'Generated {{time}} JST with {{model}}',
  insUsage: 'Today: {{n}} of {{limit}} generations, {{tokens}} tokens',
  region: 'Region',
  regionAll: 'All regions',
  regionJp: 'Japan',
  regionSg: 'Singapore',
  regionHk: 'Hong Kong',
  regionShowJapan: 'Show Japan',
  regionUnsupportedTitle: 'Not supported for {{region}} yet',
  regionUnsupportedJapanOnly: 'This page covers Japan only: the ad accounts, targets, costs and occupancy exist for Japan and cannot be split by region yet.',
  regionUnsupportedGeneric: 'This data cannot be split by region yet.',
  regionUnsupportedSearch: 'Search Console covers the whole hmlet.com domain and cannot be split into Singapore and Hong Kong yet. It is shown for Japan and for all regions.',
  regionOverviewJapanOnly: 'Targets, ad spend, ad leads, cost per lead and contract cost are Japan only and cannot be shown for this region yet. Leads, contracts, sessions and the funnel below follow the selected region.',
  regionLeadNote: 'Singapore and Hong Kong leads do not use the Japan A and B rule. Website leads are Lead Source Web経由, or Respond.io with a booking page medium. Other channels are Platform, Agents, Unbounce and other Respond.io. Other lead sources are not counted. Leads come from deals and the Pipedrive Leads inbox, and contracts are counted when the signing date is set.',
  costJapanOnlyNote: 'Cost per lead and per contract by channel are Japan only and cannot be shown for this region yet.',
  ga4RegionNote: 'Sessions are split by site: singapore.hmlet.com is Singapore, hongkong.hmlet.com is Hong Kong, every other site (hmlet.com, japan.hmlet.com) is Japan. Visitors to hmlet.com pages about Singapore or Hong Kong are still counted under Japan.',
  cmtTitle: 'This week in short',
  cmtPeriod: '{{from}} to {{to}} compared with {{pfrom}} to {{pto}}',
  cmtBasis: 'Rule based, written from the numbers on this page. It states changes and known data issues, not causes.',
  cmtNone: 'No change worth a comment this week.',
  cmtLeads_up: 'Leads up {{pct}}% ({{before}} to {{now}}).',
  cmtLeads_down: 'Leads down {{pct}}% ({{before}} to {{now}}).',
  cmtAdLeads_up: 'Ad leads (platform reported) up {{pct}}% ({{before}} to {{now}}).',
  cmtAdLeads_down: 'Ad leads (platform reported) down {{pct}}% ({{before}} to {{now}}).',
  cmtContracts_up: 'Contracts up {{pct}}% ({{before}} to {{now}}).',
  cmtContracts_down: 'Contracts down {{pct}}% ({{before}} to {{now}}).',
  cmtWeakest: 'Weakest funnel step: into {{step}}, down {{pct}}% ({{before}} to {{now}}).',
  cmtGoal_behind: '{{metric}}: behind target. The month end forecast is {{pct}}% of target and {{need}} per day are needed.',
  cmtGoal_ahead: '{{metric}}: ahead of target. The month end forecast is {{pct}}% of target.',
  cmtIssue: 'Data issue {{from}} to {{to}}: {{text}}',
  cmtUtmLow: 'Only {{pct}} of leads carry a UTM, so channel results are understated.',
  platformGoogle: 'Google Ads',
  platformMeta: 'Meta Ads',
  platformReddit: 'Reddit Ads',
  chartDailyAdLeads: 'Daily ad leads (click conversions)',
  adLeadsLagNote: 'Platform reported, click conversions only. The latest days are still rising because conversions arrive late.',
  chartDailySpendByPlatform: 'Daily ad spend by platform',
  costHiddenNote: 'Cost per lead and per contract by channel appear once UTM tracking is complete.',
  metaMissingHint: 'Google Ads spend and agency fee only. Meta and Reddit spend is not loaded yet.',
  definitionsTitle: 'What the lead numbers mean',
  definitionsNote: 'Leads: valid Pipedrive leads (A + B + LINE), invalid ones removed. Ad leads (platform reported): click conversions the ad platforms report. Web Ad Leads: Pipedrive leads whose UTM maps to an ad channel, understated until UTM reaches Pipedrive. Contracts per lead (period): contracts signed in the range divided by leads created in the range. Lead cohort CVR: share of one month\'s leads that later signed.',
  webAdLeadsHint: 'Leads whose UTM maps to an ad channel. UTM is present on {{pct}} of leads.',
  webAdLeadsUnderstated: 'Understated until UTM reaches Pipedrive.',
  webNotSplit: 'A and B are not split in Pipedrive yet',
  chartDailyLeadsAll: 'Daily leads',
  utmCoverageNote: 'Most Pipedrive leads carry no UTM source yet, so they show as unattributed. Fixing the form-to-Pipedrive sync would make channel results reliable.',
  reconLowUtm: 'Only {{pct}} of Pipedrive leads carry a UTM, so leads per channel are undercounted. Channel cost per lead uses platform-reported leads and channel CPA is hidden until UTM tracking is fixed.',
  funnelKept: 'continue',
  funnelLost: 'drop off',
  funnelScaleNote: 'Bar widths use a logarithmic scale so that every step stays visible. Compare the percentages, not the bar lengths.',
  pointsShort: 'pts',
  occupancyMonths: 'Occupancy by month',
  chartSpendLeads: 'Spend and leads by campaign',
  chartSpendLeadsAria: 'Scatter chart of ad spend and platform-reported leads, one point per campaign',
  spendLabel: 'Ad spend',
  leadsLabel: 'Leads',
  cplShort: 'Cost per lead',
  limitShort: 'Limit',
  chartCplTrend: 'Cost per lead, 7-day trend',
  chartCplTrendAria: 'Line chart of cost per lead over the trailing 7 days against the limit',
  cplTrendNote: 'Total ad spend divided by Pipedrive leads (A and B) over the last 7 days. The shaded area is under the limit.',
  spendLeadsNote: 'The dashed line is the cost per lead limit: points above it cost less per lead. Leads are the ad platforms\' own counts. Spend includes the agency fee. A campaign on the horizontal axis spent without any lead.',
  colPlatform: 'Platform',
  colSpend: 'Spend',
  targetsSource: 'Targets are read from Marketing\'s targets sheet every night (last read {{date}}). To change a target, edit the sheet.',
  targetsNeverRead: 'Targets are read from Marketing\'s targets sheet every night. The sheet has not been read yet.',
  targetsSheetLink: 'Open the targets sheet',
  targetsReadFailed: 'The last read of the targets sheet failed, so the targets shown may be out of date.',
  colChangeClicks: 'Change in clicks',
  boardTitle: 'Query board',
  boardNote: 'Queries worth a look. Search Console keeps the top queries of each day, so a query that is missing is not proof that nobody searched for it.',
  boardRising: 'Rising',
  boardFalling: 'Falling',
  boardNew: 'New',
  boardOpportunities: 'Ranking opportunities',
  boardRisingHint: 'More clicks than in the comparison period',
  boardFallingHint: 'Fewer clicks than in the comparison period, including lost queries',
  boardNewHint: 'No clicks in the comparison period',
  boardOpportunitiesHint: 'Often seen, ranked 4 to 20, not branded. A better position would bring clicks',
  boardNeedsCompare: 'Choose a comparison to see rising, falling and new queries.',
  boardEmpty: 'Nothing to show',
  boardPosition: 'Position {{n}}',
  searchNew: 'New',
  searchChangeNote: 'Change is clicks in the selected period minus clicks in the comparison period. New means no clicks in the comparison period.',
  changePassword: 'Change password',
  cpIntro: 'Use at least {{n}} characters. Avoid common passwords and the email address.',
  cpCurrent: 'Current password',
  cpNew: 'New password',
  cpConfirm: 'Confirm new password',
  cpSave: 'Save',
  cpDone: 'The password was changed.',
  cpErrWrong: 'The current password is not correct.',
  cpErrSame: 'The new password must be different from the current one.',
  cpErrMismatch: 'The two new passwords do not match.',
  cpErrLocked: 'Too many attempts. Try again in a few minutes.',
  cpErrShort: 'The new password must be at least 12 characters.',
  cpErrCommon: 'This password is too common.',
  cpErrNumeric: 'The password cannot be only numbers.',
  cpErrSimilar: 'The password is too similar to the email address.',
  cpErrOther: 'The password could not be changed. Try again.',
  navGroupDeep: 'Deep dives',
  navSegments: 'Segments',
  qSegments: 'What kinds of leads come in, and which of them go on to sign?',
  segTitle_nationality: 'Leads and conversion by nationality',
  segTitle_purpose: 'Leads and conversion by purpose of stay',
  segTitle_stay_length: 'Leads and conversion by planned length of stay',
  segTitle_previous_stay: 'Leads and conversion: first stay or returning',
  segTitle_budget: 'Leads and conversion by monthly budget',
  segTitle_language: 'Leads and conversion by contract language',
  segCol_nationality: 'Nationality',
  segCol_purpose: 'Purpose of stay',
  segCol_stay_length: 'Planned stay',
  segCol_previous_stay: 'Stay',
  segCol_budget: 'Budget',
  segCol_language: 'Language',
  segVal_nationality_japanese: 'Japanese',
  segVal_nationality_non_japanese: 'Non-Japanese',
  segVal_purpose_travel: 'Travel',
  segVal_purpose_study: 'Study',
  segVal_purpose_work: 'Work',
  segVal_purpose_other: 'Other',
  segVal_purpose_multi_location: 'Living in several places',
  segVal_purpose_returning_home: 'Returning to Japan',
  segVal_stay_length_1_3: '1 to 3 months',
  segVal_stay_length_3_6: '3 to 6 months',
  segVal_stay_length_6_12: '6 to 12 months',
  segVal_stay_length_12_plus: '12 months or more',
  segVal_previous_stay_first: 'First stay',
  segVal_previous_stay_returning: 'Stayed before',
  segVal_language_english: 'English',
  segVal_language_japanese: 'Japanese',
  segRecorded: 'Filled in for {{pct}} of leads',
  segPairs: 'Purpose of stay and nationality together',
  segNote: 'Conversion is the share of these leads that has signed up to {{date}}. Leads of the last days have not had time to sign, so a recent period reads low. Country, occupation and age are not recorded in Pipedrive, so the segments are what leads fill in on the form, and each is filled in for only part of the leads, mostly as a lead moves along, so the leads with a value signed far more often than the \'not recorded\' ones. Compare segments within one chart, not with the overall rate. Cost per contract by segment is not shown: it needs the UTM to stay on the deal.',
  segSigned: 'Signed so far',
  segSignedShort: 'signed',
  segRate: 'Conversion',
  segTileLeads: 'Leads in this view',
  segTileSigned: 'Of them signed',
  segTileRate: 'Conversion so far',
  segUnknown: 'Not recorded',
  segOther: 'Other segments',
  segLowTitle: 'Fewer than {{n}} leads, read the rate with care',
  segChangeLeads: 'Change in leads',
  segPairsNote: 'The most common combinations. A rate on a small count moves a lot with one deal.',
  segRegions: 'Regions side by side',
  segNone: 'No leads in this period.',
  navTiming: 'Inquiry timing',
  qTiming: 'When did the customers who signed first inquire, and when do new leads arrive?',
  timingContracts: 'Contracts signed',
  timingMedian: 'Median days from inquiry to contract',
  timingWithin7: 'Signed within 7 days',
  timingWithin30: 'Signed within 30 days',
  timingDaysUnit: '{{n}} days',
  chartTimingDays: 'Contracts by days from inquiry to signing',
  chartTimingMonths: 'Contracts by month of inquiry',
  timingOffset0: 'Same month as signing',
  timingOffsetN: '{{n}} months before signing',
  timingOffset1: '1 month before signing',
  timingOffsetEarlier: '{{n}} months or more before signing',
  timingBucket0: 'Same day',
  timingBucket1_3: '1 to 3 days',
  timingBucket4_7: '4 to 7 days',
  timingBucket8_14: '8 to 14 days',
  timingBucket15_30: '15 to 30 days',
  timingBucket31_60: '31 to 60 days',
  timingBucket61_90: '61 to 90 days',
  timingBucket91_plus: '91 days or more',
  chartArrivalWeek: 'Leads by week of arrival',
  chartArrivalWeekday: 'Leads by weekday (average per day)',
  timingOtherChannels: 'Other channels',
  timingUnjoined: 'Left out of the timing charts: {{noLead}} contracts with no lead record and {{before}} dated before their lead.',
  timingArrivalNote: 'The first and last week of a period can be partial. Only leads with a UTM show a channel, the rest are unattributed ({{pct}} of the leads in this period carry a UTM).',
  timingMonthsNote: 'Months are counted from the month of the inquiry to the month of signing.',
  colWeekOf: 'Week of',
  colWeekday: 'Weekday',
  colAvgPerDay: 'Average per day',
  colRange: 'Days',
  colShareOfContracts: 'Share',
  timingBucketShort0: 'Same day',
  timingBucketShort1_3: '1-3',
  timingBucketShort4_7: '4-7',
  timingBucketShort8_14: '8-14',
  timingBucketShort15_30: '15-30',
  timingBucketShort31_60: '31-60',
  timingBucketShort61_90: '61-90',
  timingBucketShort91_plus: '91+',
  timingDaysAxis: 'Days from inquiry to signing',
  navBehavior: 'On-site behaviour',
  qBehavior: 'How engaged are visitors once they arrive, and does it differ by channel?',
  behEngagement: 'Engagement rate',
  behBounce: 'Bounce rate',
  behPages: 'Pages per session',
  behTime: 'Average time engaged',
  behSeconds: '{{s}} s',
  behMinutes: '{{m}} min {{s}} s',
  chartBehChannel: 'Bounce rate by channel group',
  chartBehWeek: 'Engagement rate by week',
  behChannelNote: 'Channel groups with less than {{n}} of the sessions are left out of the chart. The first and last week of a period can be partial.',
  behDefinitions: 'A session is engaged when it lasts 10 seconds or more, has a key event or has two or more page views. Bounce rate is the share of sessions that were not engaged.',
  colEngagementRate: 'Engagement rate',
  colBounceRate: 'Bounce rate',
  colPagesPerSession: 'Pages per session',
  colAvgEngaged: 'Average time engaged',
  colKeyPer100: 'Key events / 100 sessions',
  tableBehChannel: 'Behaviour by channel group',
  ga4gDirect: 'Direct',
  ga4gOrganicSearch: 'Organic Search',
  ga4gPaidSearch: 'Paid Search',
  ga4gOrganicSocial: 'Organic Social',
  ga4gPaidSocial: 'Paid Social',
  ga4gReferral: 'Referral',
  ga4gEmail: 'Email',
  ga4gDisplay: 'Display',
  ga4gCrossNetwork: 'Cross-network',
  ga4gUnassigned: 'Unassigned',
  ga4gAffiliates: 'Affiliates',
  ga4gAudio: 'Audio',
  ga4gOrganicVideo: 'Organic Video',
  ga4gPaidVideo: 'Paid Video',
  ga4gOrganicShopping: 'Organic Shopping',
  ga4gPaidShopping: 'Paid Shopping',
  ga4gMobilePush: 'Mobile Push Notifications',
  ga4gSms: 'SMS',
  ga4gAiAssistant: 'AI Assistant',
  ga4gPaidOther: 'Paid Other',
  ga4gOrganicOther: 'Organic Other',
  pgHome: 'Home page',
  pgSearch: 'City search pages',
  pgRoom: 'Room pages',
  pgCampaign: 'Campaign pages',
  pgPreview: 'Property preview pages',
  pgAbout: 'About pages',
  pgNews: 'News pages',
  pgFaq: 'FAQ pages',
  pgOther: 'Other pages',
  pgEntry: 'No previous page',
  pgExternal: 'Another site',
  tableBehLanding: 'Landing pages (where visits start)',
  colPageType: 'Page type',
  colShareSessions: 'Share of sessions',
  tableBehJourney: 'Journey to the form',
  jrSessions: 'All sessions',
  jrSearch: 'Viewed a city search page',
  jrRoom: 'Viewed a room page',
  jrFormClick: 'Clicked through to the form',
  jrFormDone: 'Completed the form (thank-you page)',
  colOfSessions: '% of sessions',
  colOfClicked: '% of those who clicked',
  behJourneyNote: 'Each step counts the sessions that did it at least once, so one session can be in several steps. Every step is shown against all sessions. The form events are tracked for Japan only.',
  behJourneyNone: 'The journey events are tracked for Japan only, so there is nothing to show for this region.',
  tableBehJourneyChannel: 'Journey by channel group',
  colViewedRoom: 'Viewed a room',
  colClickedForm: 'Clicked to the form',
  colCompletedForm: 'Completed the form',
  tableBehMoves: 'Most common moves between pages',
  chartBehMoves: 'Most common moves between pages',
  colFromPage: 'From',
  colToPage: 'To',
  colMoves: 'Page views',
  colShareMoves: 'Share of moves',
  behMovesNote: 'Each move is a page view, grouped by the kind of page the visitor came from and went to. No previous page means the visit started there, another site means the visitor came from outside hmlet.com.',
  behFromNote: 'Landing pages, the journey and the page flow are available from {{date}}.',
  colStep: 'Step',
  navAwareness: 'Awareness effect',
  qAwareness: 'Do weeks with more awareness spend come with more branded searches and more contracts?',
  awIntro: 'Awareness spend is Meta, Google Demand Gen and Reddit (when connected), including the agency fee. This page looks for a pattern between that spend and two later results. It cannot show cause: spend, searches and contracts all rise and fall with the seasons and the marketing calendar.',
  awWindow: 'Period shown: {{from}} to {{to}} ({{days}} days), the days with awareness spend and data in every source.',
  awNone: 'There is not enough data yet. This page needs awareness spend, Search Console and Pipedrive data covering at least {{n}} days.',
  chartAwSpend: 'Awareness spend by week',
  chartAwSearch: 'Search Console clicks by week',
  chartAwContracts: 'Contracts by week',
  awBrandedClicks: 'Branded searches',
  awOtherClicks: 'Other searches',
  platformDemandGen: 'Google Demand Gen',
  tableAwLag: 'Awareness spend against later results',
  chartAwLag: 'Correlation by lag',
  colLag: 'Lag (days)',
  colBrandedCorr: 'Branded searches',
  colContractsCorr: 'Contracts',
  colDaysUsed: 'Days used',
  awStrength_none: 'No clear link',
  awStrength_weak: 'Weak',
  awStrength_moderate: 'Moderate',
  awStrength_strong: 'Strong',
  awStrength_insufficient: 'Not enough days',
  awStable: 'same direction in both halves',
  awUnstable: 'direction changes between halves',
  awLagNote: 'Each figure is the correlation (from -1 to 1) between the spend on one day and the result that many days later, after removing the day-of-week pattern. Results are indicative only, and are called stable only when the first and the second half of the period point the same way.',
  awLimitsTitle: 'What to keep in mind',
  awLimit1: 'Reddit is not connected yet, so it is not in the spend.',
  awLimit2: 'Branded searches are counted from the top queries that Search Console stores for each day.',
  awLimit3: 'Only {{n}} days of history are used. A holdout or geographic test is the reliable way to show cause.',
  awLimit4: 'Demand Gen spend starts on {{date}}, Meta on {{meta}}.',
  awLimit5: 'Meta spend is counted in full, including its lead campaigns, because the ad sheet does not mark which campaigns are for awareness.',
  behStepNote: 'Some steps are only tracked from a later date, so earlier days in the period count for nothing there: {{list}}.',
  awLag0: 'Same day',
  awLag1: '1 day later',
  awDaysLater: '{{n}} days later',
  language: 'Language',
  navAssistant: 'Analyst assistant',
  qAssistant: 'Ask a question about the marketing numbers and get an answer from the dashboard\'s own data.',
  asstPlaceholder: 'Ask about leads, contracts, costs, channels, searches, visitors...',
  asstSend: 'Ask',
  asstThinking: 'Looking up the numbers...',
  asstNew: 'New conversation',
  asstTry: 'Try asking',
  asstHow: 'How this was calculated',
  asstHowIntro: 'The numbers come from these dashboard tools, with the inputs the assistant chose:',
  asstFailedCall: 'failed',
  asstUnverified: 'These figures in the answer could not be matched to the data, check them before using them: {{list}}',
  asstQuestion: 'Question',
  asstAnswer: 'Answer',
  asstNotReady: 'The analyst assistant is not set up on this server yet, so it cannot answer questions.',
  asstOff: 'The analyst assistant is switched off on this server.',
  asstSuggest1: 'How many leads and contracts so far this month, compared with the previous period?',
  asstSuggest2: 'Which channel had the lowest cost per lead in the last 30 days?',
  asstSuggest3: 'How long do customers take from first inquiry to contract?',
  asstSuggest4: 'Which Google Ads campaigns spent the most this month?',
  asstSuggest5: 'Which search queries gained the most clicks in the last 30 days?',
  asstSuggest6: 'Where do visitors drop off before they send an inquiry?',
  asstSuggest7: 'How is the occupancy rate this month?',
  asstErr_not_configured: 'The analyst assistant is not set up on this server yet.',
  asstErr_disabled: 'The analyst assistant is switched off on this server.',
  asstErr_invalid: 'Type a question first.',
  asstErr_too_long: 'The question or the answer became too long. Ask a narrower question.',
  asstErr_busy: 'The previous question is still being answered.',
  asstErr_rate: 'Too many questions in a minute. Wait a moment and try again.',
  asstErr_limit_user: 'The limit of questions per day is reached. It resets tomorrow.',
  asstErr_limit_day: 'The daily limit of the assistant is reached. It resets tomorrow.',
  asstErr_provider: 'The AI service could not answer. Try again in a moment.',
  asstErr_too_many_steps: 'The question needed too many steps. Ask one thing at a time.',
  asstErr_refused: 'The AI service declined to answer this question.',
  asstErr_error: 'Something went wrong. Try again.',
  tool_get_overview: 'Overview numbers',
  tool_get_channels: 'Channel table',
  tool_get_ads: 'Ad campaigns',
  tool_get_search: 'Search Console',
  tool_get_timing: 'Inquiry timing',
  tool_get_behavior: 'On-site behaviour',
  tool_get_awareness: 'Awareness effect',
  tool_get_cohorts: 'Lead cohorts',
  tool_get_daily_series: 'Daily or weekly series',
  tool_get_data_status: 'Data status',
  tool_calculate: 'Calculation',
  kpiTitle: 'Month to date against target',
  kpiCaption: 'Leads and contracts come from Pipedrive with the same filters as the Pipedrive views Marketing uses. Ad leads and spend come straight from the agency sheet (Google and Meta, updated hourly, spend includes the agency fee). Forecast is the month to date pace carried to month end.',
  kpiSheetRead: 'Agency sheet last read {{time}} (every hour).',
  kpiThrough: 'Data through {{date}} 23:59 JST, {{elapsed}} of {{total}} days',
  kpiColKpi: 'KPI',
  kpiColTarget: 'Target',
  kpiColActual: 'Actual',
  kpiColVsTarget: 'vs. target',
  kpiColForecast: 'Month-end forecast',
  kpiColForecastVsTarget: 'Forecast vs. target',
  kpiLeads: 'Leads (Pipedrive, A and B)',
  kpiAdLeads: 'Ad leads (agency sheet)',
  kpiContracts: 'Contracts (Pipedrive, CW)',
  kpiSpend: 'Total ad spend (agency sheet)',
  kpiCpl: 'CPL',
  kpiAdCpl: 'Ad CPL',
  kpiCpa: 'CPA',
  kpiWithin: 'Within target',
  kpiOver: 'Over target',
  kpiNoData: 'No GA4 thank-you data yet.',
  chartKpiDailyAdLeads: 'Daily ad leads',
  chartKpiDailyAdCpl: 'Daily ad CPL',
  chartKpiDailySpend: 'Daily ad spend',
  adGroupGoogleSearch: 'Google Search',
  adGroupDemandGen: 'Demand Gen',
  adGroupMeta: 'Meta',
  adGroupChatgpt: 'ChatGPT',
  adGroupReddit: 'Reddit',
  chartKpiAdCplByGroup: 'Ad CPL by channel',
  chartKpiAdCplByGroupNote: 'Ad spend divided by ad leads for each channel. A day without ad leads has no CPL and is left out of the line.',
  moveInTitle: 'Desired move-in month',
  moveInNote: 'Leads of the selected period (same leads as the table above) by the move-in month the lead asked for.',
  moveInMonth: 'Move-in month',
  moveInShare: 'Share',
  moveInTotal: 'Total',
  moveInNotEntered: 'Not entered',
  tableCostChannels: 'Cost and cost per lead by channel',
  tableCostChannelsNote: 'Cost is the agency sheet (media cost plus agency fee). Cost per lead is that cost divided by the GA4 thank-you page completions of the same channel. A dash means no completions. Reddit is updated weekly in the sheet, so its row stops at its last day with data.',
  colCostJpy: 'Cost',
  colCompletionsShort: 'Completions',
  colCplCompletions: 'CPL',
  colDataThrough: 'Data through',
  tableTargets: 'Leads and contracts against target',
  colTargetRow: 'Row',
  colLeadsTarget: 'Leads target',
  colLeadsActual: 'Leads',
  colLeadsVs: 'Leads vs target',
  colCwTarget: 'CW target',
  colCwActual: 'CW (contracts)',
  colCwVs: 'CW vs target',
  rowTotal: 'Total',
  tableTargetsNote: 'The target is the monthly target from the Marketing targets sheet, scaled to the days in the period. Separate A and B targets are not in the sheet yet, so those rows show no target.',
  tableGaSessions: 'GA4 sessions and thank-you page completions by channel',
  colCompletions: 'Thank-you completions',
  colCompletionsA: 'Completions A',
  colCompletionsB: 'Completions B',
  kpiThroughPeriod: '{{from}} to {{to}}. Targets are the monthly targets prorated by days, and there is no month-end forecast for this period. Data through {{date}} 23:59 JST.',
  colCvr: 'CVR',
  colCvrTip: 'Thank-you page completions divided by sessions of the same channel',
  navCompetitors: 'Competitors',
  panelCompetitors: 'Competitor analysis',
  qCompetitors: 'Who do we compete with here, what do they charge and what are they doing?',
  compIndexTitle: 'Price against the market',
  compHmlet: 'Hmlet typical from price',
  compMarket: 'Market median ({{n}} competitors)',
  compVsMarket: 'Hmlet against market',
  compNoHmlet: 'No Hmlet price for this region yet. Add one under manual_prices in the competitor registry.',
  compPickRegion: 'Pick one region to see the price index. Prices are in different currencies.',
  compPricesTitle: 'Advertised monthly prices',
  compPricesNote: '"From" rents shown on their public pages, per month. Not what a person finally pays. Our own price is indicative.',
  compSiteTitle: 'Site and SEO',
  compSiteNote: 'From their sitemap and home or city pages. Speed is Google PageSpeed (mobile), shown once a Google API key is set.',
  compStackTitle: 'Marketing tools in their pages',
  compStackNote: 'Tools written into the page. Tools loaded later by a tag manager are not visible, so a missing pixel is not proof.',
  compMarketTitle: 'Reputation and search',
  compMarketNote: 'Google Maps rating, and where they rank in Google search for our keywords. Updated weekly.',
  compFeedTitle: 'What changed',
  compFeedEmpty: 'No changes yet. The feed fills from the second daily run.',
  compBlockedTitle: 'Not read automatically',
  compColCompetitor: 'Competitor',
  compColSegment: 'Segment',
  compColTypical: 'Typical from',
  compColRange: 'Range',
  compColOffers: 'Prices seen',
  compColAsOf: 'As of',
  compColPages: 'Pages',
  compColFresh: 'Updated in 90 days',
  compColLangs: 'Languages',
  compColSchema: 'Structured data',
  compColH1: 'H1',
  compColAlt: 'Images without alt',
  compColHtml: 'Page HTML',
  compColSpeed: 'Speed score',
  compColAds: 'Ad tools',
  compColOther: 'Other tools',
  compColRating: 'Google rating',
  compColTop10: 'Top 10 keywords',
  compColBest: 'Best position',
  compColWhen: 'Date',
  compColKind: 'Type',
  compColWhat: 'What',
  compSegment_furnished_monthly: 'Furnished monthly',
  compSegment_share_house: 'Share house',
  compSegment_coliving: 'Co-living',
  compSegment_serviced: 'Serviced',
  compAccess_robots: 'robots.txt forbids it',
  compAccess_challenge: 'bot wall',
  compAccess_pending: 'site not confirmed',
  compNone: 'none',
  compKind_price: 'Price',
  compKind_pages: 'Pages',
  compKind_tech: 'Tools',
  compKind_news: 'News',
  compKind_access: 'Access',
  compLastRun: 'Last run: {{runs}}',
  compMarketKind: 'Market median ({{n}} {{kind}} competitors)',
  compMarketEmpty: 'No rating or search data yet. The weekly job fills this (ratings need nothing more, search results need the SerpApi key).',
  compColYoutube: 'YouTube subscribers',
  compSummaryTitle: 'Where we stand',
  compCoverage: 'Data coverage across {{total}} operators: prices {{prices}}, speed {{speed}}, ratings {{ratings}}, YouTube {{youtube}}, search {{search}}, size {{scale}}.',
  compLegend: 'Green is good for us, yellow is borderline, red needs attention. Tints are light on purpose.',
  vPriceAbove: 'Our typical price is {{pct}}% above the median of {{n}} comparable competitors.',
  vPriceBelow: 'Our typical price is {{pct}}% below the median of {{n}} comparable competitors.',
  vSearch: 'We rank in the top 10 for {{top10}} of {{keywords}} keywords. Best rival: {{rival}} with {{rival_top10}}.',
  vSpeed: 'Our page speed score is {{score}}. The median competitor scores {{median}}.',
  vAlt: '{{pct}}% of our images have no alt text.',
  vSchemaNone: 'Our pages carry no structured data.',
  vSchemaYes: 'Our pages carry structured data ({{types}}).',
  vRating: 'Our Google rating is {{rating}}. Best rival: {{rival}} at {{rival_rating}}.',
  compColUnits: 'Size',
  compColByKind: 'By room type',
  compKind_shared: 'shared',
  compKind_private: 'private',
  compKind_studio: 'studio',
  compKind_1br: '1BR',
  'compKind_2br+': '2BR+',
  compNoPrice: 'No price data yet: {{names}}.',
  compHistoryTitle: 'Typical from price over time',
  compHistoryNote: 'Monthly. Months before today come from copies of their pages kept by the Internet Archive, so they can have gaps.',
  compSearchTitle: 'Search: who ranks for our keywords',
  compSearchNote: 'Positions in Google (best page of each operator, top 10 only). "Us" is our own Search Console over 90 days for queries containing the keyword.',
  compColKeyword: 'Keyword',
  compColRanks: 'Ranking operators',
  compColUs: 'Us (Search Console)',
  compColReach: 'Site popularity rank',
  compColWeight: 'Page weight',
  compColField: 'Real visitors',
  compThemesTitle: 'What residents say',
  compThemesNote: 'Themes from recent public Google reviews, summarised by AI. A small sample, read as a hint.',
  compColPraise: 'Praise',
  compColComplaints: 'Complaints',
  compNoSearch: 'Search data arrives with the weekly run.',
  compPlus: '{{n}} reviews',
  navDeployments: 'Deployments',
  qDeployments: 'What version is live, is a deploy running, and what changed?',
  depLiveNow: 'Live now',
  depVersion: 'Version {{version}}',
  depLiveSince: 'Live since {{when}}, deployed by {{who}}',
  depUpToDate: 'Up to date',
  depDeployingNow: 'Deploying version {{version}} now, started {{minutes}} min ago',
  depLastFailed: 'The last deploy failed. The dashboard is still running the previous version.',
  depRolledBackNote: 'The dashboard is running an older version than the last attempt (rolled back).',
  depRestarting: 'The dashboard is restarting to finish the deploy. This page keeps trying.',
  depRunLink: 'View the deploy run',
  depHistory: 'Deploy history',
  depColVersion: 'Version',
  depColBy: 'By',
  depColDuration: 'Duration',
  depColChanged: 'What changed',
  depMinutes: '{{n}} min',
  depShow: 'Show',
  depHide: 'Hide',
  depDetails: 'Technical details (commit messages)',
  depRunning: 'Deploying',
  depSucceeded: 'Live',
  depFailed: 'Failed',
  depRolledBack: 'Rolled back',
  depWrittenAuto: 'Written automatically from the code changes.',
  depFromCommits: 'From the developers\' commit messages.',
  depNoSummary: 'No description available.',
  depDirty: 'Deployed from a working copy with unsaved changes, so there is no description.',
  depEmpty: 'No deploys have been recorded yet. History starts with the next deploy. Running version: {{version}}.',
  depBackups: 'Backups',
  depBackupOk: 'A recent backup exists.',
  depBackupStale: 'The newest backup is older than a day. Check the backup job.',
  depBackupNewest: 'Newest: {{when}}, {{kb}} KB.',
  depBackupCount: '{{n}} pre-deploy dumps kept on the server.',
  depDrillOk: 'Last restore test passed ({{when}}).',
  depDrillBad: 'Last restore test FAILED ({{when}}).',
  depDrillNone: 'No restore test yet.',
  depBackupUnknown: 'Backup status is not available yet.',
  depRollbackTitle: 'Roll back',
  depRollbackNote: 'Goes back to an earlier version of the code. The database is left as it is. A backup is taken first.',
  depNoTargets: 'No earlier version is available to roll back to.',
  depSafe: 'Safe: no database changes since that version',
  depReview: 'Needs review: data migrations since that version',
  depUnsafe: 'Blocked: database changes since that version would break it',
  depImagePruned: 'Image removed',
  depBlocked: 'Blocked',
  depRollBack: 'Roll back',
  depCancel: 'Cancel',
  depConfirmTitle: 'Roll back to version {{version}} ({{sha}})?',
  depConfirmBackup: 'A database backup is taken first. The dashboard is unavailable for about 15 seconds.',
  depMigrations: 'Database changes made since that version:',
  depReviewed: 'I reviewed these migrations and want to roll back anyway.',
  depReason: 'Why are you rolling back? (required)',
  depRequests: 'Recent rollback requests',
} as const
